import client from '@/api/client'

/**
 * Get list of accounts
 *
 * @returns {Promise}
 */
export function list(requestData = {}) {
  return client
    .post('/account/v1/accounts', requestData)
    .then(response => response.data)
}

/**
 * Update account
 *
 * @param {String} id
 * @param {Object} requestData
 *
 * @returns {Promise}
 */
export function update(id, requestData = {}) {
  return client
    .patch(`/account/v1/accounts/${id}`, requestData)
    .then(response => response.data)
}

/**
 * Reset password
 *
 * @param {String} id
 *
 * @returns {Promise}
 */
export function resetPassword(id,) {
  return client
    .post(`/account/v1/accounts/${id}/reset-password`, {})
    .then(response => response.data)
}



// WEBPACK FOOTER //
// ./src/apps/accounts/api/index.js